/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { TransitionPlanningDataSet } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function TransitionPlanningDataSetCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    DataSetName: "",
    CurrentVision: "",
    CurrentMission: "",
    ProposedVisionChanges: "",
    ProposedMissionChanges: "",
    CapitalFundingAlignment: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [DataSetName, setDataSetName] = React.useState(
    initialValues.DataSetName
  );
  const [CurrentVision, setCurrentVision] = React.useState(
    initialValues.CurrentVision
  );
  const [CurrentMission, setCurrentMission] = React.useState(
    initialValues.CurrentMission
  );
  const [ProposedVisionChanges, setProposedVisionChanges] = React.useState(
    initialValues.ProposedVisionChanges
  );
  const [ProposedMissionChanges, setProposedMissionChanges] = React.useState(
    initialValues.ProposedMissionChanges
  );
  const [CapitalFundingAlignment, setCapitalFundingAlignment] = React.useState(
    initialValues.CapitalFundingAlignment
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setDataSetName(initialValues.DataSetName);
    setCurrentVision(initialValues.CurrentVision);
    setCurrentMission(initialValues.CurrentMission);
    setProposedVisionChanges(initialValues.ProposedVisionChanges);
    setProposedMissionChanges(initialValues.ProposedMissionChanges);
    setCapitalFundingAlignment(initialValues.CapitalFundingAlignment);
    setErrors({});
  };
  const validations = {
    DataSetName: [],
    CurrentVision: [],
    CurrentMission: [],
    ProposedVisionChanges: [],
    ProposedMissionChanges: [],
    CapitalFundingAlignment: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          DataSetName,
          CurrentVision,
          CurrentMission,
          ProposedVisionChanges,
          ProposedMissionChanges,
          CapitalFundingAlignment,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new TransitionPlanningDataSet(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "TransitionPlanningDataSetCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Change Transition Planning"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 16."
        {...getOverrideProps(overrides, "SectionalElement5")}
      ></Heading>
      <Text
        children="Create a record that collates data about how your organisation will position itself as the global and domestic economy transitions towards a low-emissions, climate-resilient future state."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Text
        children="You can enter more detailed data on the right hand side about your business model and strategy transition changes."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Divider>
      <TextField
        label="Transition planning record name"
        isRequired={false}
        isReadOnly={false}
        value={DataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName: value,
              CurrentVision,
              CurrentMission,
              ProposedVisionChanges,
              ProposedMissionChanges,
              CapitalFundingAlignment,
            };
            const result = onChange(modelFields);
            value = result?.DataSetName ?? value;
          }
          if (errors.DataSetName?.hasError) {
            runValidationTasks("DataSetName", value);
          }
          setDataSetName(value);
        }}
        onBlur={() => runValidationTasks("DataSetName", DataSetName)}
        errorMessage={errors.DataSetName?.errorMessage}
        hasError={errors.DataSetName?.hasError}
        {...getOverrideProps(overrides, "DataSetName")}
      ></TextField>
      <Heading
        children="NZCS1 paragraph 16a."
        {...getOverrideProps(overrides, "SectionalElement6")}
      ></Heading>
      <TextAreaField
        label="Current business model"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              CurrentVision: value,
              CurrentMission,
              ProposedVisionChanges,
              ProposedMissionChanges,
              CapitalFundingAlignment,
            };
            const result = onChange(modelFields);
            value = result?.CurrentVision ?? value;
          }
          if (errors.CurrentVision?.hasError) {
            runValidationTasks("CurrentVision", value);
          }
          setCurrentVision(value);
        }}
        onBlur={() => runValidationTasks("CurrentVision", CurrentVision)}
        errorMessage={errors.CurrentVision?.errorMessage}
        hasError={errors.CurrentVision?.hasError}
        	value={CurrentVision} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "CurrentVision")}
      ></TextAreaField>
      <TextAreaField
        label="Current strategy"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              CurrentVision,
              CurrentMission: value,
              ProposedVisionChanges,
              ProposedMissionChanges,
              CapitalFundingAlignment,
            };
            const result = onChange(modelFields);
            value = result?.CurrentMission ?? value;
          }
          if (errors.CurrentMission?.hasError) {
            runValidationTasks("CurrentMission", value);
          }
          setCurrentMission(value);
        }}
        onBlur={() => runValidationTasks("CurrentMission", CurrentMission)}
        errorMessage={errors.CurrentMission?.errorMessage}
        hasError={errors.CurrentMission?.hasError}
        	value={CurrentMission} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "CurrentMission")}
      ></TextAreaField>
      <Heading
        children="NZCS1 paragraph 16b."
        {...getOverrideProps(overrides, "SectionalElement7")}
      ></Heading>
      <TextAreaField
        label="Proposed business model changes"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              CurrentVision,
              CurrentMission,
              ProposedVisionChanges: value,
              ProposedMissionChanges,
              CapitalFundingAlignment,
            };
            const result = onChange(modelFields);
            value = result?.ProposedVisionChanges ?? value;
          }
          if (errors.ProposedVisionChanges?.hasError) {
            runValidationTasks("ProposedVisionChanges", value);
          }
          setProposedVisionChanges(value);
        }}
        onBlur={() =>
          runValidationTasks("ProposedVisionChanges", ProposedVisionChanges)
        }
        errorMessage={errors.ProposedVisionChanges?.errorMessage}
        hasError={errors.ProposedVisionChanges?.hasError}
        	value={ProposedVisionChanges} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "ProposedVisionChanges")}
      ></TextAreaField>
      <TextAreaField
        label="Proposed strategy changes"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              CurrentVision,
              CurrentMission,
              ProposedVisionChanges,
              ProposedMissionChanges: value,
              CapitalFundingAlignment,
            };
            const result = onChange(modelFields);
            value = result?.ProposedMissionChanges ?? value;
          }
          if (errors.ProposedMissionChanges?.hasError) {
            runValidationTasks("ProposedMissionChanges", value);
          }
          setProposedMissionChanges(value);
        }}
        onBlur={() =>
          runValidationTasks("ProposedMissionChanges", ProposedMissionChanges)
        }
        errorMessage={errors.ProposedMissionChanges?.errorMessage}
        hasError={errors.ProposedMissionChanges?.hasError}
        	value={ProposedMissionChanges} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "ProposedMissionChanges")}
      ></TextAreaField>
      <Heading
        children="NZCS1 paragraph 16c."
        {...getOverrideProps(overrides, "SectionalElement8")}
      ></Heading>
      <TextAreaField
        label="Describe the extent to which transition plan aspects of the strategy are aligned with internal capital deployment and funding decision-making processes"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              CurrentVision,
              CurrentMission,
              ProposedVisionChanges,
              ProposedMissionChanges,
              CapitalFundingAlignment: value,
            };
            const result = onChange(modelFields);
            value = result?.CapitalFundingAlignment ?? value;
          }
          if (errors.CapitalFundingAlignment?.hasError) {
            runValidationTasks("CapitalFundingAlignment", value);
          }
          setCapitalFundingAlignment(value);
        }}
        onBlur={() =>
          runValidationTasks("CapitalFundingAlignment", CapitalFundingAlignment)
        }
        errorMessage={errors.CapitalFundingAlignment?.errorMessage}
        hasError={errors.CapitalFundingAlignment?.hasError}
        	value={CapitalFundingAlignment} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "CapitalFundingAlignment")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
